module.exports = __webpack_public_path__ + "img/heart.0d964e0b.svg";